// extracted by mini-css-extract-plugin
export default {"addToCartControl":"m1-z","giftCard":"n1-z","btnContainer":"o1-z","cartButton":"p1-z","disabled":"q1-z"};